import { api } from '../DefaultService';
import { IConfigSimpleProps, IConfigUpdateParams, } from './types';
import {
  IDefenseProps,
  IDefenseUpdateParams,
} from '../IntegrationService/DefenseService/types';

const ENDPOINT = '/v1/licenses/config';

export const getConfigByIdAsync =
  async (): Promise<IConfigSimpleProps> => {
    return await api
      .get(`${ENDPOINT}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateConfigAsync = async ({
  data,
}: IConfigUpdateParams): Promise<IConfigSimpleProps> => {
  return await api
    .put(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
